import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 支払い状態 */
enum PaymentStatus {
  notYet = '1',
  completed = '2',
}

const nameConfig = {
  notYet: new Map([[Locale.ja, '未']]),
  completed: new Map([[Locale.ja, '済']]),
};

const toEnum = rawValueToEnum(PaymentStatus, PaymentStatus.notYet);
const toDisplay = enumToName(PaymentStatus, nameConfig);
const toDisplayWithPrefix = enumToName(PaymentStatus, nameConfig, { prefix: true });

export const paymentStatus = {
  enum: PaymentStatus,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { PaymentStatus };
